// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__8fCmp","content":"LayoutSettings_content__2RGYE"};